import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { listRescanHistory } from '../../../services/relayTransactionRescanService';
import { Resources } from '../../resource';

const resourceName = Resources.xbitRelayTransactionRescan;

const transactionRescanDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter ?? {};

    const result = await listRescanHistory({
      page,
      pageSize: perPage,
      txHash: filter.txHash || undefined,
      chainId:
        filter.chainId !== undefined && filter.chainId !== ''
          ? Number(filter.chainId)
          : undefined,
      status: filter.status || undefined,
    });

    return {
      data: result.items.map((item) => ({ ...item })),
      total: result.total,
    };
  },
};

registerModuleDataProvider(resourceName, transactionRescanDataProvider);
